import React from "react";
import useStore from "../store";

import PlayerBehaviour from "../lib/PlayerBehaviour";

import Instructions from "./Instructions";
import useOnInteractionModalStore from "./onInteractionModal/useOnInteractionModalStore";

const OnBoardingInstructions = () => {
  const {showContent: setContent} = useOnInteractionModalStore();

  const playerBehaviour = useStore<PlayerBehaviour>(
    (state) => state.playerBehaviour
  );

  return (
    <>
      <div className="bg-black bg-opacity-0 flex flex-col justify-center items-center bg-no-repeat bg-center bg-cover">
        <div className="px-12 py-8 flex flex-col items-center">
          <h2 className="py-6 uppercase font-bold text-xl text-white text-center">
            Muévete por el espacio virtual de La Torre Outlet
          </h2>

          <Instructions showDescriptions />

          <div className="mt-8 flex justify-center">
            <button
              onClick={() => {
                setContent(null);
                playerBehaviour.lockCursor();
              }}
              className="px-4 py-3 mt-4 text-center uppercase tracking-widest bg-transparent-0 hover:bg-torre-pink text-torre-pink hover:text-white border-2 border-torre-pink"
            >
              Comenzar
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnBoardingInstructions;
